module.exports = __webpack_public_path__ + "assets/img/mobile.564e1a72.svg";